/* istanbul ignore file */
import React, {
  ReactElement, ReactNode, useEffect, useState,
} from 'react';
import ReactDOM from 'react-dom';
import { useNavigate } from 'react-router-dom';
import styles from './Breadcrumbs.module.scss';
import layoutStyles from './BaseLayout.module.scss';
import PageTitle from '../PageTitle';
import { useShowContext } from 'ui-builder';

export function Breadcrumb<DataType = undefined>(
  props: {
    text: string | ((data: DataType) => string),
    href?: string,
    children?: ReactNode | false,
  },
) {
  const navigate = useNavigate();

  const showContext = useShowContext<DataType>();

  function getText() {
    if (typeof props.text === 'function') {
      const data = showContext?.data || {} as DataType;

      if (data) {
        return props.text(data);
      } else {
        return '';
      }
    } else {
      return props.text;
    }
  }

  return (
    <>
      {props.children && (
        <>
          <a
            className={styles.breadcrumb}
            href={props.href}
            onClick={(event) => {
              event.preventDefault();

              if (props.href) {
                navigate(props.href);
              }
            }}
          >
            {getText()}
          </a>
          <span className={styles.separator}>
            &gt;
          </span>
          {props.children}
        </>
      )}
      {!props.children && (
        <>
          <PageTitle text={getText()} />
          <span className={styles.breadcrumb}>
            {getText()}
          </span>
        </>
      )}
    </>
  );
}

export function BreadcrumbsPortal() {
  return (
    <div id="breadcrumbs" />
  );
}

export function BreadcrumbsPortalRenderer(props: { children: ReactElement }) {
  const element = document.getElementById('breadcrumbs');

  if (element) {
    return ReactDOM.createPortal(props.children, element);
  } else {
    return null;
  }
}

export function BreadcrumbsWrapper(
  props: {
    children: ReactElement,
  },
) {
  const [init, setInit] = useState(false);

  useEffect(() => {
    setInit(true);
  }, []);


  if (init) {
    return (
      <BreadcrumbsPortalRenderer>
        <div className={layoutStyles.breadcrumbsBlock}>
          <div className={layoutStyles.blockContent}>
            <div className={styles.breadcrumbs}>
              {props.children}
            </div>
          </div>
          <div className={layoutStyles.shadow}>
            &nbsp;
          </div>
        </div>
      </BreadcrumbsPortalRenderer>
    );
  } else {
    return null;
  }
}
